import LoginUserView from "./LoginUserView";

export const LoginUserContainer = () => {
  return (
    <div>
      <LoginUserView />
    </div>
  );
};
